import React, { useState, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';

const ManageDues = () => {
  const [response, setResponse] = useState();
  const [payData, setPayData] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDue, setSelectedDue] = useState(false);
  const [showDue, setShowDue] = useState('');
  const [showEdit, setShowEdit] = useState(false);
  const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
  const [formData, setFormData] = useState({
    amount_received: '',
    payment_mode: '',
  })

  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://api.kcmstore.in/dist/get-payment-history`);

        setLoading(false);

        if (response.ok) {
          const data = await response.json();
          console.log(data);
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          const filteredPayments = sortedProducts.filter(payment => payment.total_amount != payment.amount_received);
          setPayData(filteredPayments);
        } else {
          setLoading(false);
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };

    fetchPayments();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const showEditDialog = (paymentData) => {
    setSelectedItem(paymentData);
    setShowEdit(true);
  }

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
  };


  const handleUpdateAmount = async (e) => {
    e.preventDefault();
    setLoading(true);

    const newAmountReceived = parseFloat(selectedItem.amount_received) + parseFloat(formData.amount_received);

    try {
      const response = await fetch(`https://api.kcmstore.in/dist/update-payment/${selectedItem.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount_received: newAmountReceived.toFixed(2),
          payment_mode: formData.payment_mode,
          due_amount: selectedItem.due_amount - formData.amount_received,
        }),
      });

      setLoading(false);
      if (response.ok) {
        setResponse('Due Amount updated Successfully.');
        setPayData(prevPayData =>
          prevPayData.map(payData =>
            payData.id === selectedItem.id
              ? { ...payData, amount_received: newAmountReceived, due_amount: selectedItem.due_amount - formData.amount_received, payment_mode: formData.payment_mode }
              : payData
          )
        );
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setFormData({
          amount_received: '',
          payment_mode: '',
        })
        setShowEdit(false);
      } else {
        setLoading(false);
        setResponse('Unable to update Due Amount.')
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error updating payment:', error);
    }
  };

  const handleShowDue = (paymentData) => {
    setSelectedDue(paymentData);
    setShowDue(true);
  }


  const filteredDues = payData.filter(paymentData => {
    const isDateMatch = formatDate(paymentData.order_date).toLowerCase().includes(searchQuery.toLowerCase());
    const isUserMatch = paymentData.customer_name.toLowerCase().includes(searchQuery.toLowerCase());
    const isIdMatch = paymentData.order_id && paymentData.order_id.toString().toLowerCase().includes(searchQuery.toLowerCase());
    return isDateMatch || isUserMatch || isIdMatch;
});


  return (
    <>
      <section className='px-md-3 px-sm-3 py-3'>
        <div className='profile-area-inner px-lg-4 py-lg-4 px-3 py-3 animate__animated animate__fadeInUp'>
          <p className='profile-heading'>Manage Dues</p>
          {/* <hr className='profile-hr' /> */}


          <div className="text-start mb-4">
                        <input
                            type="text"
                            className="profile-input rounded border-0 bg-light"
                            placeholder="Search Here..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>


          {filteredDues.length > 0 ? (
            filteredDues.map((paymentData) => (
              <div className='due-area my-2'>
                <div className='d-flex justify-content-between'>
                  <span><span className='fw-semibold'>{paymentData.customer_name}</span><br /><br />
                    Order Date: {formatDate(paymentData.order_date)}<br />
                    <span className='fw-semibold text-success'>Amount Payable: ₹{Number(paymentData.total_amount).toFixed(2)}</span><br /><span className='fw-semibold text-danger'>Due Amount: ₹{Number(paymentData.due_amount).toFixed(2)}</span>
                  </span>

                  <div className='text-center'>  <p className='due-tag cursor-pointer' onClick={() => handleShowDue(paymentData)}>View</p>
                    <p className='due-tag cursor-pointer' onClick={() => showEditDialog(paymentData)}>Manage</p>
                  </div>
                </div>


              </div>
            ))
          ) : (
            <p className='fw-semibold my-3'>No Dues Yet.</p>
          )}

        </div>
      </section>


      {showEdit && (
        <>
          <section className='detail-dialog animate__animated animate__zoomIn' onClick={() => setShowEdit(false)}>
            <div className='detail-dialog-inner col-xl-4 col-lg-5 col-md-8 col-sm-10 col-12 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>
              <p className='profile-subheading my-3'>Due Amount: ₹ {selectedItem.due_amount}</p>

              <form className="row g-3 bg-white rounded-4 mb-4" onSubmit={handleUpdateAmount}>
                {/* Product Name */}

                <div className="col-12">
                  <label htmlFor="amount_received" className="profile-label text-muted">Amount</label>
                  <input
                    type="text"
                    className="profile-input"
                    id="amount_received"
                    value={formData.amount_received}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-12">
                  <label className="profile-label text-muted" htmlFor="payment_mode">Payment Mode</label>
                  <select
                    className="profile-input"
                    id="payment_mode"
                    value={formData.payment_mode}
                    onChange={handleChange}
                    required
                  >
                    <option value="Cash" selected>Cash</option>
                    <option value="UPI">UPI</option>
                    <option value="Debit Card">Debit Card</option>
                    <option value="Credit Card">Credit Card</option>
                  </select>
                </div>

                <div className='col-12'>
                  <button className='login-btn bg-danger' onClick={() => setShowEdit(false)}>Close</button>&nbsp;&nbsp;
                  <button className='login-btn'>Update</button>
                </div>

              </form>

            </div>
          </section>
        </>
      )}


      {showDue && (
        <>

          <section className='detail-dialog px-2'>
            <div className='detail-dialog-inner col-lg-5 col-md-8 mx-auto px-3 py-4 rounded-4'>

              <p className='profile-subheading'>Due Details</p>

              <div className='due-area'>
                <p className='fw-semibold'>Party Name: {selectedDue.customer_name}</p>
                <p>Invoice No: {selectedDue.id}<br />Order Id: {selectedDue.order_id}<br />Order Date: {formatDate(selectedDue.order_date)}<br />
                  Payment Mode: {selectedDue.payment_mode}<br /><br />Total Amount Payable: ₹{Number(selectedDue.total_amount).toFixed(2)}<br /><br />
                  <span className='text-success fw-semibold'>Amount Paid: ₹{Number(selectedDue.amount_received).toFixed(2)}</span><br />
                  <span className='text-danger fw-semibold'>Due Amount: ₹{Number(selectedDue.due_amount).toFixed(2)}</span></p>
              </div>

              <button className='login-btn px-3 py-1 mt-3' onClick={() => setShowDue(false)}>Close</button>&nbsp;&nbsp;

            </div>
          </section>
        </>
      )}

{loading && <Loading setLoading={setLoading} />}
{response && <ResponseMsg message={response} />}

    </>
  )
}

export default ManageDues
